import Api from '../services/Api'
import LocalStorage from '@/services/LocalStorageService'

const root = () => `dashboard/${LocalStorage.getClientPrefix()}`

class DashboardService {
  async getGeneralStatusChartData (year = '', month = '', day = '', process = '', integration = '') {
    const params = { year, month, day, process, integration }
    return Api().get(`${root()}/process`, { params })
  }

  async getTemporalStatusChartData (year = '', month = '', day = '', process = '', integration = '') {
    const params = { year, month, day, process, integration }
    return Api().get(`${root()}/temporal`, { params })
  }
}

export default new DashboardService()
